import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { ERR_MSG_404_TEMPLETE_ID } from '../../../constants/msgText'
import { getSettingFormProjectObjectiveOutcomeIndicator } from '../../../redux/actions/subProjectFormSetting'
import ProjectObjectiveOutcomeIndicatorSettingWidget from '../../../widgets/projectProposal/projectObjectiveOutcomeIndicator/ProjectObjectiveOutcomeIndicatorSettingWidget'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'

export default function ProjectObjectiveOutcomeIndicatorSetting(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    if (formId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_TEMPLETE_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSettingFormProjectObjectiveOutcomeIndicator(formId)
      // const _schema = mockSchema
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProjectSetting>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

          {schema.buttonRoute && <BtnEditAll routing={schema.buttonRoute} hiddenBtnEdit />}

          {schema?.forms?.objectiveOutcomeIndicator && (
            <ProjectObjectiveOutcomeIndicatorSettingWidget
              schema={schema.forms.objectiveOutcomeIndicator}
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
